export default "__VITE_ASSET__fizXknbb__"